import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { VchasnoKasaService } from '../../services/vchasno-kasa.service';
import { BoardPaymentService } from '../../services/board-payment.service';
import { CashRegister } from './prro.types';

@Component({
  selector: 'app-cash-register-form',
  standalone: false,
  templateUrl: './cash-register-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full min-h-0' },
})
export class CashRegisterFormComponent implements OnInit {
  @Input() register: CashRegister | null = null;
  @Output() close = new EventEmitter<CashRegister | undefined>();
  private readonly api = inject(VchasnoKasaService);
  private readonly feedback = inject(BoardPaymentService);
  private readonly destroyRef = inject(DestroyRef);
  protected name = '';
  protected token = '';
  protected busy = false;

  ngOnInit(): void {
    this.name = this.register?.name ?? '';
  }

  requestClose(): void {
    if (this.busy) return;
    this.token = '';
    this.close.emit();
  }

  protected save(): void {
    if (this.busy || !this.name.trim() || (!this.register && !this.token.trim())) return;
    this.busy = true;
    this.api
      .saveRegister(this.register?.id ?? null, {
        name: this.name.trim(),
        ...(this.token.trim() ? { api_token: this.token.trim() } : {}),
      })
      .pipe(finalize(() => (this.busy = false)), takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (register) => {
          this.token = '';
          this.close.emit(register);
        },
        error: (error) => this.feedback.error(error),
      });
  }
}
